import React from 'react'

const NavLinks = () => {
  return (
    <div className='nav-links'>
        <a href="#" className="navItem">product</a>
        <a href="#" className="navItem">features</a>
        <a href="#" className="navItem">pricing</a>
        <a href="#" className="navItem fade">.</a>
        <a href="#" className="navItem fade">login</a>
    </div>
  )
}

export default NavLinks